<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import { mapGetters, mapActions, mapState } from "vuex";
import Swal from "sweetalert2";
import moment from "moment";
import axios from "axios";
import ExcelImport from "@/components/ExcelImport.vue";
import DataTable from "@/components/DataTable.vue";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Shop Purchases",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    ExcelImport,
    DataTable,
  },
  data() {
    return {
      title: "Purchase Report",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Shop Purchases Report",
          active: true,
        },
      ],

      pageOptions: [10, 25, 50, 100, 200, 1000],
      serverPerPage: 50,
      IsPurchasesDataServerPaginated: true,
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      returnData: {
        purchase_id: "",
        product_id: "",
        product_name: "",
        quantity: "",
        unit_price: "",
        batch: "",
        date: moment(new Date()).format("YYYY-MM-DD"),
        reason: "",
        mode: "",
        type: 0,
        filterdata: {},
      },
      edit: {
        id: "",
        total: "",
        paid: "",
        mode: "",
        filterdata: {},
      },
      deleteData: {
        id: "",
        filterdata: {},
      },
      editData: {
        id: "",
        filterdata: {},
      },
      amountError: "",
      modeError: "",

      data: {
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        datefrom: moment(new Date()).format("YYYY-MM-DD"),
        supplier: "",
        branch_id: 0,
        product: "",
        invoiceno: "",
        page: 1,
        per_page: 50,
      },

      submitData: {
        id: "",
        filterdata: {},
      },

      PurchaseQuantity: 0,
      is_uploading: false,
      QtyError: "",
      ReasonError: "",

      excelTemplateFields: {
        Date: "Date",
        "Supplier Name": "Supplier Name",
        "Supplier Contact": "Supplier Contact",
        Total: "Total",
        Paid: "Paid",
        Discount: "Discount",
        "Invoice No": "Invoice No",
        "Product Name": "Product Name",
        Category: "Category",
        Unit: "Unit",
        "Product Code": "Product Code",
        "Minimum Quantity": "Minimum Quantity",
        "Quantity Bought": "Quantity Bought",
        "Cost Price": "Cost Price",
        "Retail Price": "Retail Price",
        "Wholesale Price": "Wholesale Price",
        "Batch Number": "Batch Number",
        "Expiry Date": "Expiry Date",
      },
      excelRequiredHeaders: ["Date", "Product Name"],
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("purchase", [
      "SaveStatus",
      "PurchasesData",
      "PurchasesDataPagination",
      "PurchasesReturn",
      "ReturnId",
      "PurchasesDataSummary",
      "PurchasesDataPaginated",
    ]),
    ...mapGetters("auth", [
      "MyUserPerm",
      "business",
      "branch",
      "Branches",
      "branchid",
    ]),
    ...mapGetters("setting", ["PaymentOptions", "GeneralSettings"]),
    ...mapGetters("stock", ["Suppliers"]),
    ...mapGetters("products", ["Products"]),

    purchaseColumns() {
      const cols = [
        {
          key: "sn",
          label: "S/N",
          formatter: (_, __, idx) =>
            this.PurchasesDataPagination?.from
              ? this.PurchasesDataPagination.from + idx
              : idx + 1,
        },
        {
          key: "status",
          label: "STATUS",
          formatter: (_, row) =>
            row.efrisstatus ? "Synchronized" : "Unsynchronized",
        },
        { key: "product", label: "PRODUCT" },
        {
          key: "qty",
          label: "QTY",
          formatter: (_, row) =>
            // row.items?.map((i) => i.qty + (i.usymbol || "")).join(", "),
            row?.items?.map((i) => i.qty + (i.usymbol || "")).join(", ") || "",
        },
        {
          key: "price",
          label: "PRICE",
          formatter: (_, row) =>
            row.items
              ?.map((i) =>
                i.unitPrice ? this.thousandSeperator(i.unitPrice) : "0"
              )
              .join(", ") || "",
        },
        {
          key: "batch",
          label: "BATCH",
          formatter: (_, row) =>
            this.GeneralSettings?.track_expiries && row?.items
              ? row.items.map((i) => i.batch || "").join(", ")
              : "",
        },
        {
          key: "totAmt",
          label: "TOTAL",
          formatter: (v) => this.thousandSeperator(v),
        },
        {
          key: "amtPaid",
          label: "PAID",
          formatter: (v) => this.thousandSeperator(v),
        },
        {
          key: "discount",
          label: "DISCOUNT",
          formatter: (v) => this.thousandSeperator(v),
        },
        {
          key: "supplier",
          label: "SUPPLIER",
          formatter: (v) => v || "N/A",
        },
      ];

      // Add INVOICE column if enabled
      if (this.GeneralSettings?.capture_purchase_invoiceno) {
        cols.splice(10, 0, {
          key: "invoiceno",
          label: "INVOICE NO",
        });
      }

      cols.push(
        { key: "date", label: "DATE" },
        { key: "user", label: "RECORDED BY" },
        { key: "actions", label: "ACTIONS", tdClass: "text-nowrap" }
      );

      return cols;
    },

    rows() {
      return this.IsPurchasesDataServerPaginated
        ? this.PurchasesDataPagination?.total
        : this.PurchasesData
          ? this.PurchasesData.length
          : 0;
    },

    perPage: {
      get() {
        if (this.IsPurchasesDataServerPaginated) {
          return (
            (this.PurchasesDataPagination &&
              this.PurchasesDataPagination.per_page) ||
            this.data.per_page ||
            this.serverPerPage
          );
        } else {
          return this.serverPerPage;
        }
      },
      set(value) {
        if (this.IsPurchasesDataServerPaginated) {
          this.data.per_page = value;
          this.data.page = 1;
          this.FetchPurchases(this.data);
        } else {
          this.serverPerPage = value;
        }
      },
    },

    currentPage: {
      get() {
        return this.PurchasesDataPaginated && this.PurchasesDataPagination
          ? this.PurchasesDataPagination.current_page
          : 1;
      },
      set(value) {
        if (this.PurchasesDataPaginated) {
          this.data.page = value;
          this.handlePageChange(value);
        }
      },
    },

    totals() {
      return (
        this.PurchasesDataSummary || {
          totalAmount: 0,
          totalPaid: 0,
          totalDiscount: 0,
          totalBalance: 0,
        }
      );
    },
  },
  watch: {
    show(newValue) {
      if (newValue == true) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
    ReturnId(newValue) {
      if (newValue) {
        this.$router.push(`/print_purchase_return/${btoa(newValue)}`);
      }
    },
  },

  methods: {
    ...mapActions({
      FetchPurchases: "purchase/fetchShopPurchasesData",
      EditPaid: "purchase/editAmtPaidMode",
      EditPurchase: "purchase/editPurchase",
      DeletePurchase: "purchase/deletePurchase",
      FetchModes: "setting/fetchPaymentOptions",
      FetchReturns: "purchase/fetchReturns",
      SaveReturn: "purchase/returnShopPurchase",
      SaveReturnPrint: "purchase/returnShopPurchasePrint",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
      FetchSuppliers: "stock/fetchSuppliers",
      FetchProducts: "products/fetchProducts",
      SubmitPurchase: "purchase/submitPurchase",
    }),

    thousandSeperator(m) {
      if (m !== "" && m !== undefined && m !== 0 && m !== "0" && m !== null) {
        return m
          .toString()
          .replace(/[^0-9.]+/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    resetModal() {
      this.edit.id = "";
      this.edit.total = "";
      this.edit.paid = "";
      this.edit.mode = "";
    },
    resetError() {
      this.amountError = "";
      this.modeError = "";
      this.ReasonError = "";
    },
    resetDelete() {
      this.deleteData.id = "";
    },
    resetEdit() {
      this.editData.id = "";
    },
    showEditModal(data) {
      this.editData.id = data.item.id;
    },
    showDeleteModal(data) {
      this.deleteData.id = data.item.id;
      this.deleteData.filterdata = this.data;
    },
    addCommas() {
      this.edit.paid = this.thousandSeperator(this.edit.paid.replace(/,/g, ""));
    },
    ShowEdit(data) {
      this.edit.id = data.id;
      this.edit.mode = data.payments[0].mode;
      this.edit.total = data.totAmt;
      this.edit.paid = this.thousandSeperator(data.amtPaid);
    },
    editAmt(modalId) {
      this.modal_id = modalId;
      if (this.edit.paid == "") {
        this.amountError = "Amount Paid is required";
        return;
      } else {
        this.amountError = "";
      }
      if (this.edit.mode == "") {
        this.modeError = "Payment Method is required";
        return;
      } else {
        this.modeError = "";
      }
      let payload = { ...this.edit };
      payload.paid = String(payload.paid).replace(/,/g, "");
      payload.filterdata = this.data;
      this.EditPaid(payload);
    },
    editPurchase(modalId) {
      this.editData.filterdata = this.data;
      this.modal_id = modalId;
      this.EditPurchase(this.editData);
    },
    deletePurchase(modalId) {
      this.modal_id = modalId;
      this.DeletePurchase(this.deleteData);
    },
    closeModal(modalId) {
      this.resetError();
      this.resetModal();
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
    Receipt_print(Id) {
      window.open(
        `https://${window.location.host
        }/receipts/purchasesreceipt.php?id=${btoa(Id)}`
      );
    },
    Showreturn_modal(data) {
      this.PurchaseQuantity = data.qty;
      this.returnData.purchase_id = data.purchase.id;
      this.returnData.product_id = data.product_id;
      this.returnData.product_name = data.product;
      this.returnData.unit_price = data.SPrice;
      this.returnData.quantity = data.qty;
      this.returnData.batch = data.batch;
    },
    resetSave() {
      // this.resetErrors();
      this.returnData.purchase_id = "";
      this.returnData.product_id = "";
      this.returnData.product_name = "";
      this.returnData.quantity = "";
      this.returnData.unit_price = "";
      this.returnData.batch = "";
      this.returnData.reason = "";
      this.returnData.date = moment(new Date()).format("YYYY-MM-DD");
      this.returnData.mode = "";
      this.modal_id = "";
    },
    Return_purchase(modalId) {
      this.modal_id = modalId;
      if (this.returnData.quantity > this.PurchaseQuantity) {
        this.QtyError = "Quantity returned is greater than quantity purchased!";
        return;
      } else {
        this.QtyError = "";
      }
      if (this.returnData.reason == "") {
        this.ReasonError = "Reason field is required";
        return;
      } else {
        this.ReasonError = "";
      }
      this.returnData.filterdata = this.data;
      this.SaveReturn(this.returnData);
    },

    Return_purchasePrint(modalId) {
      this.modal_id = modalId;
      // Validation logic remains the same
      if (this.returnData.quantity > this.PurchaseQuantity) {
        this.QtyError = "Quantity returned is greater than quantity purchased!";
        return;
      } else {
        this.QtyError = "";
      }
      if (this.returnData.reason == "") {
        this.ReasonError = "Reason field is required";
        return;
      } else {
        this.ReasonError = "";
      }
      this.returnData.filterdata = this.data;
      this.SaveReturnPrint(this.returnData);
    },

    filterReport() {
      let payload = { ...this.data };
      payload.page = 1;
      payload.per_page = this.IsPurchasesDataServerPaginated
        ? this.perPage
        : this.serverPerPage;

      this.FetchPurchases(payload);
    },

    handlePageChange(newPage) {
      if (this.IsPurchasesDataServerPaginated) {
        this.data.page = newPage;
        this.FetchPurchases(this.data);
      }
    },

    Excel_export() {
      this.spinner = true;
      axios
        .post("export_shoppurchases", this.data, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", "purchases_report.xlsx");
          document.body.appendChild(fileLink);
          fileLink.click();
          document.body.removeChild(fileLink);
          this.spinner = false;
        })
        .catch(() => {
          this.spinner = false;
          Swal.fire("Error!", "Could not export data.", "error");
        });
    },

    handleUpload() {
      this.file = this.$refs.file.files[0];
    },

    importFile(modelId) {
      if (!this.file) {
        Swal.fire("Error!", "Please select a file to upload.", "error");
        return;
      }
      this.is_uploading = true;
      let formData = new FormData();
      formData.append("file", this.file);

      const headers = { "Content-Type": "multipart/form-data" };
      axios
        .post("import_purchases", formData, { headers })
        .then((res) => {
          this.is_uploading = false;
          this.closeModal(modelId);
          if (res.status == 200) {
            let message = { msg: res.data.message || "Successful upload" };
            this.FetchPurchases(this.data);
            this.$store.dispatch("notification/success", message);
          } else {
            let message = {
              msg: res.data.message || "Something went wrong and upload failed",
            };
            this.$store.dispatch("notification/error", message);
          }
        })
        .catch((error) => {
          this.is_uploading = false;
          this.closeModal(modelId);
          let errorMsg = "Something went wrong and upload failed";
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            errorMsg = error.response.data.message;
          }
          let message = { msg: errorMsg };
          this.$store.dispatch("notification/error", message);
        });
    },

    // Excel import event handlers
    handleExcelImportSuccess(result) {
      Swal.fire(
        "Success!",
        result.message || "Purchases imported successfully!",
        "success"
      );
      this.FetchPurchases(this.data);
      this.closeModal("import-purchases-modal");
    },

    handleExcelImportError() {
      Swal.fire(
        "Error!",
        "There was an error while importing the data. Please try again",
        "error"
      );
    },

    // Custom validation for Excel import
    validatePurchasesData(data) {
      const errors = [];

      data.forEach((row, index) => {
        const rowNum = index + 2;

        // Date validation when data exists
        if (row.Date && String(row.Date).trim() !== "") {
          const date = new Date(row.Date);
          if (isNaN(date.getTime())) {
            errors.push(`Row ${rowNum}: Date must be a valid date format`);
          }
        }

        // Supplier Contact validation
        if (
          row["Supplier Contact"] &&
          String(row["Supplier Contact"]).trim() !== ""
        ) {
          const contact = String(row["Supplier Contact"]).trim();

          // Check if it's a valid integer (only digits)
          if (!/^\d+$/.test(contact)) {
            errors.push(
              `Row ${rowNum}: Supplier Contact must be a valid number (integers only)`
            );
          }
          // Check length (max 11 digits)
          else if (contact.length > 11) {
            errors.push(
              `Row ${rowNum}: Supplier Contact should not exceed 11 digits`
            );
          }
        }

        // Validate numeric fields if they exist
        const numericFields = [
          "Total",
          "Paid",
          "Discount",
          "Minimum Quantity",
          "Quantity Bought",
          "Cost Price",
          "Retail Price",
          "Wholesale Price",
        ];
        numericFields.forEach((field) => {
          if (
            row[field] !== null &&
            row[field] !== undefined &&
            row[field] !== ""
          ) {
            const value = Number(row[field]);
            if (Number.isNaN(value) || value < 0) {
              errors.push(
                `Row ${rowNum}: ${field} must be a valid non-negative number`
              );
            }
          }
        });

        // Expiry Date validation when data exists
        if (row["Expiry Date"] && String(row["Expiry Date"]).trim() !== "") {
          const expiryDate = new Date(row["Expiry Date"]);
          if (isNaN(expiryDate.getTime())) {
            errors.push(
              `Row ${rowNum}: Expiry Date must be a valid date format`
            );
          }
        }
      });

      return errors;
    },
    showSubmitModal(data) {
      this.submitData.id = data.id;
    },
    submitPurchase(modalId) {
      this.submitData.filterdata = this.data;
      this.modal_id = modalId;
      this.SubmitPurchase(this.submitData);
    },
  },

  created() {
    this.FetchPurchases(this.data);
    this.FetchModes();
    this.FetchGeneralSettings();
    this.FetchSuppliers();
    this.FetchProducts();
  },
};
</script>

<template>
  <Layout>
    <!-- Header -->
    <div class="row py-3 text-center">
      <h4 v-if="GeneralSettings.show_businessname == 1" class="text-primary">
        {{ business }}
      </h4>
      <h4 v-if="GeneralSettings.show_branchname == 1 && branch">
        <em v-if="
          GeneralSettings.show_branchname == 1 &&
          GeneralSettings.show_businessname == 1
        ">-</em>
        {{ branch }}
      </h4>
    </div>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- Import Button & Branch Filter -->
            <div class="row">
              <div class="col-md-4 mb-2">
                <div v-if="GeneralSettings.import_purchases == 1 && branchid != 0">
                  <b-button v-b-modal.import-purchases-modal variant="info"><i class="fa fa-plus"></i> Import Purchases
                  </b-button>
                </div>
              </div>
              <div class="col-md-4"></div>
              <div class="col-md-4 mb-3" v-if="branchid == 0">
                <label>FILTER BY BRANCHES</label>
                <model-list-select :list="Branches
                    ? [{ id: 0, name: 'All Branches' }, ...Branches]
                    : []
                  " v-model="data.branch_id" option-value="id" option-text="name" placeholder="Select Branch"
                  @input="filterReport()">
                </model-list-select>
              </div>
            </div>

            <!-- Export Button & Title -->
            <div class="row mt-4">
              <div class="col-3">
                <b-button variant="info" @click="Excel_export()"><i class="fa fa-download"></i>Export
                </b-button>
              </div>
              <div class="col-md-9">
                <h3 class="card-title mb-2 text-center" v-html="title"></h3>
              </div>
            </div>

            <!-- Product Filter -->
            <div class="row">
              <div class="col-md-9"></div>
              <div class="col-md-3 form-group">
                <label>PRODUCT</label>
                <model-list-select :list="Products
                    ? [{ id: '', name: 'All Products' }, ...Products]
                    : []
                  " v-model="data.product" option-value="id" option-text="name" placeholder="Select Product"
                  @input="filterReport()">
                </model-list-select>
              </div>
            </div>

            <!-- Date, Supplier, Invoice Filters -->
            <div class="row">
              <div class="col-md-2">
                <div class="form-group">
                  <label>From</label>
                  <input type="date" v-model="data.datefrom" class="form-control" v-limit-future-date/>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>To</label>
                  <input type="date" v-model="data.dateto" class="form-control" v-limit-future-date/>
                </div>
              </div>
              <div class="col-md-3 form-group">
                <label>SUPPLIERS</label>
                <model-list-select :list="Suppliers
                    ? [{ id: '', name: 'All Suppliers' }, ...Suppliers]
                    : []
                  " v-model="data.supplier" option-value="id" option-text="name" placeholder="Select Supplier"
                  @input="filterReport()">
                </model-list-select>
              </div>
              <div class="col-md-3 form-group">
                <label>INVOICE NO.</label>
                <input class="form-control" v-model="data.invoiceno" placeholder="Enter Invoice No" />
              </div>
              <div class="col-md-2 mt-4">
                <button class="btn btn-primary" type="button" @click="filterReport()">
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner v-show="SaveStatus" variant="light" small role="status"></b-spinner>
                </button>
              </div>
            </div>

            <!-- Per Page & Search -->
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select class="form-select form-select-sm" v-model="perPage" size="sm"
                      :options="pageOptions"></b-form-select>&nbsp;entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end"
                  v-if="!IsPurchasesDataServerPaginated">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>

            <!-- Table Area -->
            <div class="table-responsive mb-0">
              <DataTable :columns="purchaseColumns" :rows="PurchasesData || []" :total-rows="rows"
                :pagination="PurchasesDataPagination" :server-pagination="IsPurchasesDataServerPaginated"
                :loading="SaveStatus" row-class="purchase-table-bordered">
                <template #cell(sn)="{ index }">
                  {{ PurchasesDataPagination.from + index }}
                </template>

                <template #cell(status)="{ row }" :class="'purchase-row-end'">
                  <button class="btn btn-info btn-sm" v-b-modal.purchase-submit-modal @click="showSubmitModal(row)"
                    v-if="MyUserPerm.edit_purchase == 1 && !row.efrisstatus">
                    Synchronize
                  </button>
                  <button class="btn btn-sm" disabled v-if="MyUserPerm.edit_purchase == 1 && row.efrisstatus">
                    <h6>Synchronized</h6>
                  </button>
                </template>

                <template #cell(product)="{ row }">
                  <div v-if="row && row.items">
                    <div v-for="(det, d) in row.items" :key="d" class="mb-4">
                      {{ det.product }}
                    </div>
                  </div>
                </template>

                <template #cell(qty)="{ row }">
                  <div v-if="row && row.items">
                    <div v-for="(det, d) in row.items" :key="d" class="mb-4">
                      {{ det.qty }}{{ det.name }}
                    </div>
                  </div>
                </template>

                <template #cell(price)="{ row }">
                  <div v-if="row && row.items">
                    <div v-for="(det, d) in row.items" :key="d" class="mb-4">
                      {{ det.unitPrice ? thousandSeperator(det.unitPrice) : 0 }}
                    </div>
                  </div>
                </template>

                <template #cell(batch)="{ row }">
                  <div v-if="GeneralSettings.track_expiries && row && row.items">
                    <div v-for="(det, d) in row.items" :key="d" class="mb-4">
                      {{ det.batch }}
                    </div>
                  </div>
                </template>

                <template #cell(totAmt)="{ value }">
                  {{ thousandSeperator(value) }}
                </template>

                <template #cell(amtPaid)="{ row, value }">
                  <span class="text-warning" style="cursor: pointer" v-b-modal.expired-modal @click="ShowEdit(row)"
                    v-if="row.numpaid == 1 && MyUserPerm.edit_purchase == 1">
                    {{ thousandSeperator(value) }}
                  </span>
                  <span v-else>{{ thousandSeperator(value) }}</span>
                </template>

                <template #cell(discount)="{ value }">
                  {{ thousandSeperator(value) }}
                </template>

                <template #cell(supplier)="{ value }">
                  {{ value || "N/A" }}
                </template>

                <template v-if="GeneralSettings.capture_purchase_invoiceno" #cell(invoiceno)="{ row }">
                  {{ row.invoiceno }}
                </template>

                <template #cell(date)="{ value }">
                  {{ value }}
                </template>

                <template #cell(user)="{ value }">
                  {{ value || "N/A" }}
                </template>

                <template #cell(actions)="{ row }">
                  <b-dropdown text="More Actions..." size="sm" class="btn-primary"
                    v-if="MyUserPerm.modify_purchases == 1">
                    <b-dropdown-item v-if="MyUserPerm.delete_purchase == 1" v-b-modal.delete-purchase-modal
                      @click="showDeleteModal({ item: row })">
                      <i class="fa fa-trash text-danger"></i>
                      <span class="text-danger"> Delete</span>
                    </b-dropdown-item>

                    <b-dropdown-item v-if="MyUserPerm.edit_purchase == 1" v-b-modal.edit-purchase-modal
                      @click="showEditModal({ item: row })">
                      <i class="fa fa-edit text-primary"></i>
                      <span class="text-primary"> Edit</span>
                    </b-dropdown-item>

                    <b-dropdown-item variant="info" @click="Receipt_print(row.id)">
                      <i class="fa fa-download"></i> Reprint
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
              </DataTable>
            </div>

            <div class="row mt-2 font-weight-bold">
              <div class="col-md-3">
                <h5>
                  Total Amount:
                  <span class="text-danger">{{
                    thousandSeperator(totals.totalAmount)
                  }}</span>
                </h5>
              </div>
              <div class="col-md-3">
                <h5>
                  Total Paid:
                  <span class="text-danger">{{
                    thousandSeperator(totals.totalPaid)
                  }}</span>
                </h5>
              </div>
              <div class="col-md-3">
                <h5>
                  Total Discount:
                  <span class="text-danger">{{
                    thousandSeperator(totals.totalDiscount)
                  }}</span>
                </h5>
              </div>
              <div class="col-md-3">
                <h5>
                  Total Balance:
                  <span class="text-danger">{{
                    thousandSeperator(totals.totalBalance)
                  }}</span>
                </h5>
              </div>
            </div>

            <!-- Pagination Controls -->
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"
                      aria-controls="tickets-table"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>

            <!-- resynchronise mode starts -->
            <b-modal header-bg-variant="info" header-text-variant="light" body-text-variant="info"
              footer-bg-variant="info" footer-text-variant="info" id="purchase-submit-modal" hide-footer
              @hidden="resetEdit">
              <template #modal-title> Resubmit This Purchase</template>
              <div class="form-group mb-2">
                <div class="input-group">
                  <h5>
                    You are submitting this purchase to URA? Click Proceed Button to Submit
                    the Purchase.
                  </h5>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal"
                  @click="closeModal('purchase-submit-modal')">
                  <i class="fa fa-times"></i> Close
                </button>
                <button v-if="SaveStatus" type="button" class="btn btn-primary" disabled>
                  <i class="fa fa-check"></i> Proceed
                  <b-spinner variant="light" small label="Submitting"></b-spinner>
                </button>
                <button v-else type="button" class="btn btn-primary" @click="submitPurchase('purchase-submit-modal')">
                  <i class="fa fa-check"></i> Proceed
                </button>
              </div>
            </b-modal>
            <!-- resynchronise mode ends -->

            <!-- Modals -->
            <b-modal id="return-purchase-modal" hide-footer @hidden="resetSave">
              <template #modal-title>
                Return {{ returnData.product_name }}</template>
              <div class="form-group mb-3">
                <label>Return Date</label>
                <div class="input-group">
                  <input type="date" placeholder="Enter Date" class="form-control" v-model="returnData.date" />
                </div>
              </div>
              <div class="form-group mb-3">
                <label>Quantity</label>
                <div class="input-group">
                  <input type="number" placeholder="Enter quantity" class="form-control" v-model="returnData.quantity"
                    @input="QtyError = ''" />
                </div>
                <div class="text-danger" v-if="QtyError">
                  <em>{{ QtyError }}</em>
                </div>
              </div>
              <div class="form-group mb-3">
                <label>Reason</label>
                <div class="input-group">
                  <textarea type="text" placeholder="Enter reason" class="form-control" v-model="returnData.reason"
                    @input="ReasonError = ''"></textarea>
                </div>
                <div class="text-danger" v-if="ReasonError">
                  <em>{{ ReasonError }}</em>
                </div>
              </div>
              <div class="form-group mb-3">
                <label>Payment Option</label>
                <div class="input-group">
                  <model-list-select :list="PaymentOptions ? PaymentOptions : []" v-model="returnData.mode"
                    option-value="id" option-text="mode" placeholder="Select Mode">
                  </model-list-select>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-md-5">
                  <button v-if="SaveStatus" type="button" class="btn btn-primary" disabled>
                    <i class="fa fa-check"></i>
                    Submit & Print
                    <b-spinner variant="light" small label="Spinning"></b-spinner>
                  </button>
                  <button v-else type="button" class="btn btn-primary"
                    @click="Return_purchasePrint('return-purchase-modal')">
                    <i class="fa fa-check"></i>
                    Submit & Print
                  </button>
                </div>
                <div class="col-md-2"></div>
                <div class="col-md-5 d-flex justify-content-end">
                  <button v-if="SaveStatus" type="button" class="btn btn-primary" disabled>
                    <i class="fa fa-check"></i>
                    Submit & Exit
                    <b-spinner variant="light" small label="Spinning"></b-spinner>
                  </button>
                  <button v-else type="button" class="btn btn-primary"
                    @click="Return_purchase('return-purchase-modal')">
                    <i class="fa fa-check"></i>
                    Submit & Exit
                  </button>
                </div>
              </div>
            </b-modal>
            <!-- Modals -->

            <b-modal id="expired-modal" hide-footer @hidden="resetModal()">
              <template #modal-title>
                <h4 class="text-warning">
                  Edit Amount Paid For Purchase of
                  {{ thousandSeperator(edit.total) }}
                </h4>
              </template>
              <label>Amount Paid</label>
              <div class="input-group">
                <input type="text" class="form-control" v-model="edit.paid" placeholder="Amount Paid"
                  @input="resetError(), addCommas()" />
              </div>
              <div class="text-danger" v-if="amountError">
                <em>{{ amountError }}</em>
              </div>
              <div class="form-group mt-2">
                <label>Payment Method <span class="text-danger">*</span></label>
                <model-list-select :list="PaymentOptions ? PaymentOptions : []" v-model="edit.mode" option-value="id"
                  option-text="mode" placeholder="Select Method" @input="resetError()">
                </model-list-select>
              </div>
              <div class="text-danger" v-if="modeError">
                <em>{{ modeError }}</em>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal"
                  @click="closeModal('expired-modal')">
                  <i class="fa fa-times"></i> Close
                </button>
                <button type="button" class="btn btn-warning" @click="editAmt('expired-modal')">
                  <i class="fa fa-check"></i> Confirm
                  <b-spinner v-if="SaveStatus" variant="light" small label="Submiting"></b-spinner>
                </button>
              </div>
            </b-modal>

            <b-modal header-bg-variant="warning" header-text-variant="light" body-text-variant="warning"
              footer-bg-variant="warning" footer-text-variant="warning" id="edit-purchase-modal" hide-footer
              @hidden="resetEdit">
              <template #modal-title> Edit Purchase</template>
              <div class="form-group mb-2">
                <div class="input-group">
                  <h5>
                    Do you want to return and edit this Purchase? Click Proceed
                    Button to Return Purchase for Editing.
                  </h5>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal"
                  @click="closeModal('edit-purchase-modal')">
                  <i class="fa fa-times"></i> Close
                </button>
                <button type="button" class="btn btn-primary" @click="editPurchase('edit-purchase-modal')">
                  <i class="fa fa-edit"></i> Proceed
                  <b-spinner v-if="SaveStatus" variant="light" small label="Processing"></b-spinner>
                </button>
              </div>
            </b-modal>

            <b-modal header-bg-variant="danger" header-text-variant="light" body-text-variant="danger"
              footer-bg-variant="danger" footer-text-variant="danger" id="delete-purchase-modal" hide-footer
              @hidden="resetDelete">
              <template #modal-title> Delete Purchase</template>
              <div class="form-group mb-2">
                <div class="input-group">
                  <h5>
                    Do you want to delete this Purchase? Click Proceed Button to
                    delete.
                  </h5>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal"
                  @click="closeModal('delete-purchase-modal')">
                  <i class="fa fa-times"></i> Close
                </button>
                <button type="button" class="btn btn-danger" @click="deletePurchase('delete-purchase-modal')">
                  <i class="fa fa-trash"></i> Proceed
                  <b-spinner v-if="SaveStatus" variant="light" small label="Deleting"></b-spinner>
                </button>
              </div>
            </b-modal>

            <!--PURCHASES EXCEL UPLOAD MODAL-->
            <b-modal id="import-purchases-modal" ref="modal" hide-footer title="Import Purchases from Excel"
              @hidden="file = null">
              <template #modal-title> Import Purchases from Excel </template>
              <template>
                <ExcelImport :template-fields="excelTemplateFields" template-filename="purchases_import_template.xlsx"
                  upload-label="Select Excel file with purchases data:" import-url="import_purchases"
                  :required-headers="excelRequiredHeaders" :custom-validation="validatePurchasesData"
                  @import-success="handleExcelImportSuccess" @import-error="handleExcelImportError"
                  @close-modal="closeModal('import-purchases-modal')" />
              </template>
            </b-modal>
            <!-- PURCHASES EXCEL UPLOAD END -->
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}

.form-control:disabled,
.form-control[readonly] {
  background-color: #e9ecef;
  opacity: 1;
}

.purchase-table-bordered td {
  border-bottom: 1px solid #000 !important;
}
</style>
